import { useEffect, useState } from "react";

function PDFViewer({ base64 }) {
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    if (!base64) {
      console.warn("📄 No Base64 PDF received.");
      return;
    }

    console.log("📄 Received Base64 PDF. Processing...");

    try {
      // ✅ Strip Base64 metadata if it exists
      const base64WithoutPrefix = base64.startsWith("data:application/pdf")
        ? base64.split(",")[1]
        : base64;

      // ✅ Convert Base64 to Binary Data
      const binaryData = atob(base64WithoutPrefix);
      const byteNumbers = new Uint8Array(binaryData.length);

      for (let i = 0; i < binaryData.length; i++) {
        byteNumbers[i] = binaryData.charCodeAt(i);
      }

      // ✅ Create Blob URL
      const blob = new Blob([byteNumbers], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      setPdfUrl(blobUrl);
      
      console.log("✅ Blob URL created:", blobUrl);

      // Cleanup Blob URL on unmount
      return () => URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("❌ Failed to process Base64 PDF:", error);
    }
  }, [base64]);

  return (
    <div style={{ width: "100%", height: "90vh", border: "1px solid #ccc" }}>
      {pdfUrl ? (
        <iframe
          src={pdfUrl}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="PDF Viewer"
        ></iframe>
      ) : (
        <p>⚠️ No PDF Available</p>
      )}
    </div>
  );
}

export default PDFViewer;
